import { render, staticRenderFns } from "./salon_entrance.vue?vue&type=template&id=1521862f&scoped=true"
import script from "./salon_entrance.vue?vue&type=script&lang=js"
export * from "./salon_entrance.vue?vue&type=script&lang=js"
import style0 from "./salon_entrance.vue?vue&type=style&index=0&id=1521862f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1521862f",
  null
  
)

export default component.exports